import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {BigWinView} from '@fantasmagames/slot/src/modules/bigwin/BigWinView';
import {BigWinModule} from '@fantasmagames/slot/src/modules/bigwin/BigWinModule';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';

export class BigWinFinalState extends ModuleState<BigWinView, BigWinModule> {
	public onEnterState(): void {
		this.emit(BigWinEvents.COUNTUP_FINISHED);
		this.view.playBigWinEnd();
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(BigWinView.SKIP_CLICKED, this.onFinishBigWin);
		this.on(BigWinView.END_ANIMATION_FINISHED, this.onEndAnimationFinished);
	}

	protected onFinishBigWin(): void {
		this.view.playEndingEndAnimation();
	}

	protected onEndAnimationFinished(): void {
		this.module.soundPlayer.restoreGameMusic(this.module.logic);
		this.emit(BigWinEvents.FINISHED);
		this.module.gotoState(BigWinModule.BASIC_STATE);
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bigwin/states/BigWinFinalState.ts